(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pebble-product-spotlight"]) return;
  try {
    
if (!customElements.get('pebble-product-spotlight')) {
  customElements.define('pebble-product-spotlight', class extends HTMLElement {
    connectedCallback() {
      this.card = this.querySelector('.pebble-spotlight__card');
      this.content = this.querySelector('.pebble-spotlight__content');
      this.preview = Boolean(window.Shopify?.designMode);
      this.items = [...this.querySelectorAll('template[data-product]')];
      this.eligible = this.items.filter(t => this.preview || new URL(t.dataset.url,location.origin).pathname !== location.pathname);
      if (!this.card || !this.eligible.length || (!this.preview && this.dataset.enabled !== 'true')) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.key = 'tinitigies:spotlight:v1:' + this.dataset.section;
      this.signature = this.dataset.order + ':' + this.items.map(t => t.dataset.product).join(',');
      this.state = this.load();
      this.querySelector('button').addEventListener('click', () => this.dismiss(), {signal});
      this.addEventListener('keydown', e => { if(e.key === 'Escape') this.dismiss(); }, {signal});
      if (this.preview) { this.content.replaceChildren(this.items[0].content.cloneNode(true)); this.card.hidden=false; return; }
      this.observer = new MutationObserver(() => { if(this.blocked() && !this.card.hidden) { this.card.hidden=true; this.schedule(2000); } });
      // Observe overlay state only, never the full product DOM or cart contents.
      const wrapper = document.querySelector('.page-wrapper');
      if(wrapper) this.observer.observe(wrapper,{attributes:true,attributeFilter:['class']});
      document.querySelectorAll('dialog').forEach(d=>this.observer.observe(d,{attributes:true,attributeFilter:['open']}));
      document.addEventListener('visibilitychange',()=>{ if(document.hidden) { this.card.hidden=true; clearTimeout(this.timer); } else this.schedule(2000); },{signal});
      this.schedule(Number(this.dataset.delay)*1000);
    }
    load() {
      let state;
      try { state=JSON.parse(sessionStorage.getItem(this.key)); } catch (_) { /* Storage can be disabled; keep a page-local session. */ }
      if(!state || Date.now()-state.touched>1800000) state={count:0,index:0,dismissed:false,touched:Date.now()};
      if(state.signature!==this.signature) {
        state.order=this.items.map(t=>t.dataset.product);
        if(this.dataset.order==='random') for(let i=state.order.length-1;i>0;i--) { const j=Math.floor(Math.random()*(i+1)); [state.order[i],state.order[j]]=[state.order[j],state.order[i]]; }
        state.signature=this.signature; state.index=0;
      }
      return state;
    }
    save() { this.state.touched=Date.now(); try { sessionStorage.setItem(this.key,JSON.stringify(this.state)); } catch (_) {} }
    blocked() { return document.hidden || Boolean(document.querySelector('dialog[open],.page-wrapper--drawer-open')) || (this.dataset.mobile!=='true' && matchMedia('(max-width:700px)').matches); }
    schedule(ms) { clearTimeout(this.timer); if(this.state.dismissed || this.state.count>=Number(this.dataset.limit)) return; this.timer=setTimeout(()=>this.show(),ms); }
    show() {
      if(!this.isConnected) return;
      if(this.blocked()) { this.schedule(2000); return; }
      let item;
      for(let n=0;n<this.state.order.length;n++) {
        const id=this.state.order[this.state.index++ % this.state.order.length];
        item=this.eligible.find(t=>t.dataset.product===id);
        if(item) break;
      }
      if(!item) return;
      const id=item.dataset.product;
      this.content.replaceChildren(item.content.cloneNode(true));
      this.card.hidden=false;
      this.state.count++; this.save();
      this.dispatchEvent(new CustomEvent('pebble:spotlight-view',{bubbles:true,detail:{productId:id}}));
      this.timer=setTimeout(()=>this.finish(),Number(this.dataset.duration)*1000);
    }
    finish() {
      // Never remove a focused link or a card the visitor is reading with a pointer.
      if(this.contains(document.activeElement) || this.matches(':hover')) { this.timer=setTimeout(()=>this.finish(),2000); return; }
      this.card.hidden=true;
      const a=Number(this.dataset.min), b=Number(this.dataset.max);
      this.schedule((Math.min(a,b)+Math.random()*Math.abs(b-a))*1000);
    }
    dismiss() { this.card.hidden=true; clearTimeout(this.timer); if(!this.preview) { this.state.dismissed=true; this.save(); } }
    disconnectedCallback() { clearTimeout(this.timer); this.observer?.disconnect(); this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
